// import React from 'react';
// import {  Route, Routes } from 'react-router-dom';
// import { Card } from 'antd';
// import Home from './Home';
// import CLComponents from './CLComponents/index';
// import NavBar from './Navbar';
// import EnglishLabelChange from './englishLabelChange';
// import StudyPlan from './study-plan';
// import AO from './AO';
// import AbsentRMs from './AbsentRMs';
// import DailySheet from './MathMorningSheetStatus';
// import MathEveningDailySheet from './MathEveningSheetStatus';
// import EnglishMorningDailySheet from './EnglishMorningSheetStatus';
// import EnglishEveningDailySheet from './EnglishEveningSheetStatus';
// import MathLabelChange from "./MathLabelChange"
// import '../App.css';

// function App() {

//   return (
//     <div className="App">
//       <Card style={{height:'100px'}}>
//         <NavBar/>
//       </Card>
//       <Routes>
//           <Route path="/home" element={<Home/>} />        
//           <Route path="/studyPlan" element={<StudyPlan/>} />
//           <Route path="/EnlishLabel" element={<EnglishLabelChange/>} />
//           <Route path="/MathLabel" element={<MathLabelChange/>} />
//           <Route path="/AO" element={<AO/>} />
//           <Route path="/AbsentRMs" element={<AbsentRMs/>} />
//           <Route path="/DailySheet" element={<DailySheet/>} />
//           <Route path="/MathEveningDailySheet" element={<MathEveningDailySheet/>} />
//           <Route path="/EnglishMorningDailySheet" element={< EnglishMorningDailySheet/>} />
//           <Route path="/EnglishEveningDailySheet" element={<EnglishEveningDailySheet/>} />
//           <Route path="/cl/*" element={<CLComponents/>} />   
//       </Routes>
//     </div>
//   );
// }

// export default App;



import React from 'react';
import {  Route, Routes } from 'react-router-dom';
import { Card } from 'antd';
import Home from './Home';
import CLComponents from './CLComponents/index';
import NavBar from './Navbar';
import EnglishLabelChange from './englishLabelChange';
import StudyPlan from './study-plan';
import AO from './AO';
import AbsentRMs from './AbsentRMs';
import DailySheet from './MathMorningSheetStatus';
import MathEveningDailySheet from './MathEveningSheetStatus';
import EnglishMorningDailySheet from './EnglishMorningSheetStatus';
import EnglishEveningDailySheet from './EnglishEveningSheetStatus';
import MathLabelChange from "./MathLabelChange"
import '../App.css';

function App() {

  return (
    <div className="App">
      <Card style={{height:'100px'}}>
        <NavBar/>
      </Card>
      <Routes>
          <Route path="/home" element={<Home/>} />        
          <Route path="/studyPlan" element={<StudyPlan/>} />
          <Route path="/MathLabel" element={<MathLabelChange/>} />
          <Route path="/EnlishLabel" element={<EnglishLabelChange/>} />
          <Route path="/AO" element={<AO/>} />
          <Route path="/AbsentRMs" element={<AbsentRMs/>} />
          <Route path="/DailySheet" element={<DailySheet/>} />
          <Route path="/MathEveningDailySheet" element={<MathEveningDailySheet/>} />
          <Route path="/EnglishMorningDailySheet" element={< EnglishMorningDailySheet/>} />
          <Route path="/EnglishEveningDailySheet" element={<EnglishEveningDailySheet/>} />   
          <Route path="/cl/*" element={<CLComponents/>} />   
      </Routes>
    </div>
  );
}

export default App;